module.exports = __webpack_public_path__ + "img/img_04.79d05717.jpg";